export const ru = {
    'normal-view-title': 'Добавьте быстрые ссылки в объявления',
    'normal-view-title-hint': 'Показывается, потому что у вас есть объявления без быстрых ссылок',
    'popup-view-title': 'Добавьте быстрые ссылки в объявление',
    'popup-view-title-hint': 'Показывается, потому что у объявления нет быстрых ссылок',
    'show-many-banner-button': 'Посмотреть {count} объявлений',
    'show-one-banner-button': 'Посмотреть {count} объявление',
    'show-some-banner-button': 'Посмотреть {count} объявления',
    'site-links-desc1':
        'Быстрые ссылки повышают кликабельность объявления без дополнительных затрат. Если пользователь при просмотре объявления кликнет на несколько ссылок, вы заплатите только за один клик.',
    'site-links-desc2':
        'В быстрых ссылках вы можете рассказать о ваших предложениях, описать выгодные условия доставки или добавить другую информацию, которая не уместилась в основной текст объявления.'
};
